import { useAppSelector } from "../../store/hooks"
import { selectSearch } from "../../store/router/selectors"

export const useNotificationExists = () => {
    const search = useAppSelector(selectSearch)
    return !!search && search.indexOf("notificationId") !== -1
}
